import { useMemo } from "react";

export const useGetGroupedArrayOrders = (orderData) => {
    const grouped = useMemo(() => {
        if (!orderData) return null;
        return (
            orderData?.reduce((groups, order) => {
                const orderDate = order?.creationDate;
                const date = orderDate?.split("T")[0];
                if (!groups[date]) {
                    groups[date] = [];
                }
                groups[date].push({ ...order, orderDate });
                return groups;
            }, {}) || {}
        );
    }, [orderData]);

    const groupedArrays = useMemo(() => {
        if (!grouped) return null;
        return Object.keys(grouped)
            ?.map((date) => {
                return {
                    date,
                    orders: grouped[date],
                };
            })
            ?.sort((a, b) => Number(new Date(b?.date)) - Number(new Date(a?.date)) || []);
    }, [grouped]);

    return {
        groupedArrays,
    };
};
